import { useUserInfoContext } from '../../context/UserInfoContext';

import NotLoggedIconButton from './NotLoggedIconButton';
import LoggedInIconButton from './LoggedInIconButton';

const LoginIconButton = () => {
  const { isUserLogged } = useUserInfoContext();

  return isUserLogged ? <LoggedInIconButton /> : <NotLoggedIconButton />;
};

export default LoginIconButton;
